import { type Writable } from 'svelte/store';

export type BindableValue<T> = Writable<T> | T;

// normalizes usage of store variable and reactive variable
export function createBindableState<T>(
  getValue: () => BindableValue<T>,
  setValue: (v: T) => void,
  defaultValue: T
) {
  function isStore(value: any): value is Writable<T> {
    return value && typeof value.subscribe === 'function';
  }

  const currentProp = getValue();
  
  if (isStore(currentProp)) {
    // sync with local state
    let localValue = $state(defaultValue);
    
    // Sync FROM store TO local
    $effect(() => {
      const unsubscribe = currentProp.subscribe(v => {
          localValue = v;
      });
      return unsubscribe;
    });

    // Sync FROM local TO store
    $effect(() => {
        currentProp.set(localValue);
    });

    return {
      get current() {
        return localValue;
      },
      set current(v: T) {
        localValue = v;
      }
    };
  } else {
    return {
      get current() {
        return getValue() as T;
      },
      set current(v: T) {
        setValue(v);
      }
    };
  }
}